import moment from 'moment';

function viewVisits(memberId) {
  const startDate = moment(endDate).subtract(1, 'months').format('MM/DD/YYYY');
  const endDate = moment().format('MM/DD/YYYY');

  window.open(`/members/${memberId}/consultations?consultation_id=&consultation_member_id=${memberId}&status=&specialty=General+Medical&first_name_member=&last_name_member=&first_name_provider=&last_name_provider=&start_date=${startDate}&end_date=${endDate}&commit=search`)
}
export default viewVisits;
